import { render, staticRenderFns } from "./ElectionPart.vue?vue&type=template&id=41db99e0"
import script from "./ElectionPart.vue?vue&type=script&lang=js"
export * from "./ElectionPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports